import { Link } from 'react-router-dom';
import { articles } from '@/mocks/gossip';

const featured = articles[0];
const sideList = articles.slice(1, 6);

export default function HotBoard() {
  return (
    <section className="mx-auto w-full max-w-6xl px-4 py-14 md:px-6 md:py-20">
      <div className="flex flex-col gap-3 border-b-2 border-foreground-950 pb-4 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <span className="text-xs font-medium tracking-[0.25em] text-primary-600">TODAY HOT</span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">今日热瓜</h2>
        </div>
        <Link
          to="/gossip"
          className="flex items-center gap-1 whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-700"
        >
          查看全部榜单
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="mt-8 grid gap-8 lg:grid-cols-5">
        <article className="group relative overflow-hidden rounded-lg lg:col-span-3">
          <Link to={`/gossip/${featured.id}`} className="block" aria-label={featured.title}>
            <div className="relative h-[340px] w-full overflow-hidden md:h-[420px]">
              <img
                src={featured.cover}
                alt={featured.title}
                title={`${featured.title} - 爆瓜福利`}
                className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/40 to-transparent"></div>
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
                <i className="ri-fire-fill"></i>
                全网热议
              </span>
              <h3 className="mt-4 font-heading text-xl font-bold leading-8 text-background-50 md:text-2xl md:leading-9">
                {featured.title}
              </h3>
              <p className="mt-3 line-clamp-2 hidden text-sm leading-6 text-background-100/85 sm:block">
                {featured.summary}
              </p>
              <div className="mt-4 flex items-center gap-4 text-xs text-background-100/80">
                <span>{featured.author}</span>
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  {featured.views.toLocaleString('zh-CN')}
                </span>
                <span>{featured.date}</span>
              </div>
            </div>
          </Link>
        </article>

        <div className="rounded-lg border border-background-200 bg-background-100 p-5 lg:col-span-2">
          <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
            <i className="ri-list-ordered text-primary-600"></i>
            热门排行
          </h3>
          <div className="mt-2">
            {sideList.map((article, index) => (
              <div key={article.id} className="flex items-start gap-4 border-b border-background-200 py-4 last:border-b-0">
                <span
                  className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-sm font-bold ${
                    index < 3 ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-700'
                  }`}
                >
                  {index + 1}
                </span>
                <div className="min-w-0">
                  <Link to={`/gossip/${article.id}`}>
                    <h4 className="line-clamp-2 text-sm font-medium leading-6 text-foreground-900 transition-colors hover:text-primary-700">
                      {article.title}
                    </h4>
                  </Link>
                  <p className="mt-1 line-clamp-1 text-xs text-foreground-500">{article.summary}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}